export default __webpack_public_path__ + "static/media/myclassroom_logo.4d4bcb13.svg";